import React, { useState, useContext } from 'react';
import { Disclosure } from '@headlessui/react';
import Footer from '../components/footer';
import { ChevronUpIcon } from '@heroicons/react/20/solid';
import BackButton from '../components/back_button';
import PermissionsTable from '../components/permissions_configurazione_parametri';
import GiustificativiSelected from '../components/giustificativi_selected';
import RateiTable from '../components/ratei_table';
import FestivitaTable from '../components/holidays_table';
import TimbraturaSetting from '../components/timbratura_setting';
import OrarioLavoroSetting from '../components/orario_lavoro_setting';
import CompanyEmailSetting from '../components/company_email_setting';
import { AuthContext } from "../contexts/auth";
import { Link } from 'wouter';
import PopoverComponentCustom from '../components/popover_component';



function SettingsDisclosure({ title, color, grade, gradeHover, tableComponent: TableComponent }) {
    const [isOpen, setIsOpen] = useState(false);
    const [showForm, setShowForm] = useState(false);
  
    return (
        <div className="mx-0 px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-center">
                <div className="container flex w-full justify-center bg-white rounded-lg shadow overflow-hidden mt-5">
                    <div className="rounded mb-4 w-full">
                        <Disclosure>
                            {({ open }) => (
                                <>
                                    <Disclosure.Button
                                        className={`flex w-full justify-between bg-${color}-${grade} px-4 py-4 text-left text-sm font-medium text-gray-900 hover:bg-${color}-${gradeHover}`}
                                        onClick={() => setIsOpen(!isOpen)}
                                    >
                                        <span>{title}</span>
                                        <ChevronUpIcon
                                            className={`${
                                                !open ? 'rotate-180 transform' : ''
                                            } h-5 w-5 text-white-500`}
                                        />
                                    </Disclosure.Button>
                                    <Disclosure.Panel className="px-4 pb-2 pt-4 text-sm text-gray-500">
                                        {isOpen && <TableComponent showForm={showForm} setShowForm={setShowForm} />}
                                    </Disclosure.Panel>
                                </>
                            )}
                        </Disclosure>
                    </div>
                </div>
            </div>
        </div>
    );
}

const ConfigurazioneParametri = () => {
    const { profile } = useContext(AuthContext)

    const isProfileComplete = profile.has_complete_profile;

    const disclosureData = [
        { title: 'Impostazione Ricezione Email', color: 'gray', grade: '200', gradeHover: '300', tableComponent: CompanyEmailSetting },
        { title: 'Autorizzazioni e Ruoli', color: 'gray', grade: '200', gradeHover: '300', tableComponent: PermissionsTable },
        { title: 'Ratei', color: 'gray', grade: '200', gradeHover: '300', tableComponent: RateiTable },
        { title: 'Giustificativi', color: 'gray', grade: '200', gradeHover: '300', tableComponent: GiustificativiSelected },
        { title: 'Festività', color: 'gray', grade: '200', gradeHover: '300', tableComponent: FestivitaTable },
        { title: 'Timbrature', color: 'gray', grade: '200', gradeHover: '300', tableComponent: TimbraturaSetting },
        { title: 'Impostazione Lavoro Notturno', color: 'gray', grade: '200', gradeHover: '300', tableComponent: OrarioLavoroSetting }
    ];


    return (
        <div className="min-h-full">
            <PopoverComponentCustom title='Configurazione Parametri' />
            {profile?.customer_type === 'company' && !isProfileComplete && profile?.company?.email == profile?.the_real_user_email && (
                <div className="w-full">
                    <div className="bg-orange-100 text-orange-600 p-4">
                        <p className="text-center text-sm font-semibold">
                            Il profilo non è completo. <br />
                            Compila i campi mancanti{' '}
                        <Link
                            to="/profilo/fatturazione"
                            className="text-indigo-600 hover:text-indigo-800 underline"
                        >
                            cliccando qui
                        </Link>
                            .
                        </p>
                    </div>
                </div>
            )}
            <main className="mt-10 pb-8">
                <div className='flex justify-end my-4 mr-10'>
                    <BackButton prevLocation="/" />
                </div>
                <div className="container-fluid w-full px-4 pt-2">
                    <div className="mx-0 w-full rounded-2xl bg-white p-2">
                        {disclosureData.map((data, index) => (
                            <SettingsDisclosure
                                key={index}
                                title={data.title}
                                color={data.color}
                                grade={data.grade}
                                gradeHover={data.gradeHover}
                                tableComponent={data.tableComponent}
                            />
                        ))}
                    </div>
                    {/* <div className='flex justify-center mt-4'>
                        <button className='bg-rose-800 hover:bg-rose-600 text-white font-bold py-2 px-4 rounded-md focus:outline-none focus:shadow-outline w-40'>Salva</button>
                    </div> */}
                </div>
            </main>
           <Footer />
        </div>
    );
};

export default ConfigurazioneParametri;
